import { Link } from '@mui/material';
import { useRecoilState } from 'recoil';
import { viewManagerState } from '~/state/atoms/engineAtoms';

const ResetViewButton = () => {
    const [viewManager] = useRecoilState(viewManagerState);

    const resetView = () => {
        if (viewManager) {
            viewManager.resetViews();
        }
    };

    return (
        <Link
            component="button"
            variant="body2"
            value="reset-view"
            underline="none"
            fontSize={12}
            onClick={() => {
                resetView();
            }}
            sx={{
                lineHeight: 1,
                padding: 0,
            }}
        >
            RESET
        </Link>
    );
};

export default ResetViewButton;
